import React, { memo, useEffect, useState } from 'react';
import '../../scss/dt_profile.scss';
import '../../scss/dt_profileRight.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../../../../components/ContentSlider/css/contentSlider.scss';
import { DoctubeSupport } from '../../../../../components/icons';
import { getCurrentTime, getLocalStorage } from '../../../../../common/common';
import { useDispatch } from 'react-redux';
import { PopupModal, useCalendlyEventListener } from 'react-calendly';
import packageJson from '../../../../../../package.json';
import { fetchCTA, postAnalyticsCTA, updateCtaSchedule } from '../../../../../Store/actions';
import { toast } from 'react-toastify';
import { EmailUpdateModal, PhoneUpdateModal } from '../../../../../components/modals';
import Loader from 'react-loader-spinner';
import ScheduleSectionSkeleton from '../../../../../skeleton/doctube/dashboard/SheduleSectionSkeleton';
const REQUEST_TYPE_CALLBACK = 1;
const REQUEST_TYPE_SCHEDULE = 2;
let currentActionType = '';
const content_type = 'doctube';
const content_id = 0;
const SheduleSection = () => {
  const [
    {
      id,
      cta_url,
      callback_status,
      schedule_status,
      cta_type,
      cta_type_id,
      type,
      type_id,
      position
    },
    setData
  ] = useState({});
  const getCtaData = () =>
    dispatch(
      fetchCTA(content_type, content_id, (res) => {
        if (res?.data?.length > 0) {
          setData(res.data[0]);
          console.log('Shedule doctube cta', res.data[0]);
        }
        setLoader(false);
      })
    );
  useEffect(() => {
    getCtaData();
    return () => { };
  }, []);

  const [email, setEmail] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.email : ''
  );
  const [phone, setPhone] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.mobile_primary : ''
  );
  const [phoneModalShow, setPhoneModalShow] = useState(false);
  const [emailModalShow, setEmailModalShow] = useState(false);

  const [isd, setIsd] = useState('+91');
  const [otp, setOtp] = useState('');

  const [popupUrl, setPopupUrl] = useState('');
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [first_name, set_first_name] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.first_name : ''
  );

  const [middle_name, set_middle_name] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.middle_name : ''
  );

  const [last_name, set_last_name] = useState(
    getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.last_name : ''
  );

  const [isLoading, setIsLoading] = useState(false);

  const [loader, setLoader] = useState(true);
  const dispatch = useDispatch();
  const pageSettings = {
    backgroundColor: 'ffffff',
    hideEventTypeDetails: false,
    hideLandingPageDetails: false,
    primaryColor: '00a2ff',
    textColor: '4d5055'
  };
  const prefill = {
    email: email ?? '',
    firstName: first_name ?? '',
    lastName: last_name ?? ' ',
    name: `${first_name} ${middle_name} ${last_name}`,

    // guests: ['name@example.com'],
    customAnswers: {
      a1: phone ? `${isd}${phone}` : ''
    },
    date: new Date(Date.now() + 86400000)
  };
  let utm = {
    utmCampaign: '',
    utmContent: window.location.href,
    utmMedium: `CLIRNET v${packageJson.version}`,
    utmSource: getLocalStorage('utm_source', false)
      ? getLocalStorage('utm_source', 'not found')
      : '',
    utmTerm: ''
  };
  useCalendlyEventListener({
    onProfilePageViewed: (e) => console.log('onProfilePageViewed' + JSON.stringify(e.data)),
    onDateAndTimeSelected: (e) => console.log('onDateAndTimeSelected' + JSON.stringify(e.data)),
    onEventTypeViewed: (e) => console.log('onEventTypeViewed' + JSON.stringify(e.data)),
    onEventScheduled: (e) => updateScheduleCallBackData(JSON.stringify(e.data.payload))
  });

  const onRequestCallbackClick = () => {
    currentActionType = REQUEST_TYPE_CALLBACK;
    validateEmailAndPhone(REQUEST_TYPE_CALLBACK);
  };

  const onScheduleClick = () => {
    currentActionType = REQUEST_TYPE_SCHEDULE;
    validateEmailAndPhone(REQUEST_TYPE_SCHEDULE);
  };

  const updateSchedule = (params_type) => {
    var currentTime = '';
    console.log('temp data @@@@@@@@', {
      cta_id: id ?? 0,
      contact_type: params_type,
      schedule: 123,
      content_type: content_type ?? 0,
      content_id: content_id ?? 0,
      schedule_data: getCurrentTime() ?? ''
    });
    if (id && currentActionType == REQUEST_TYPE_CALLBACK && !isLoading) {
      // if (currentActionType == REQUEST_TYPE_CALLBACK) {
      setIsLoading(true);

      let currentTime = '';
      currentTime = getCurrentTime();
      console.log('updateSchedule');
      let temp_json_data = {
        cta_id: id,
        contact_type: params_type,
        schedule: 123,
        content_type: content_type ?? 0,
        content_id: content_id ?? 0,
        schedule_data: currentTime ?? ''
      };

      dispatch(
        updateCtaSchedule(temp_json_data, (response) => {
          setIsLoading(false);
          console.log('no callback xid' + JSON.stringify(response));
          currentActionType = '';
          if (response.status_code == 200) {
            let postObj = {
              cta_type,
              cta_type_id,
              target_type: type,
              target_type_id: type_id,
              position,
              cta_id: id
            };

            toast.success(response.message);
            getCtaData();
            dispatch(postAnalyticsCTA(postObj, () => { }));
          }
        })
      );
    } else if (id && currentActionType == REQUEST_TYPE_SCHEDULE) {
      setPopupUrl(cta_url);
      setIsPopupOpen(true);
    } else {
      toast.success('Something Wrong Happen');
    }
  };

  const updateScheduleCallBackData = (schedule_data = '') => {
    if (id) {
      setIsLoading(true);
      console.log('updateSchedule');
      let temp_json_data = {
        cta_id: id,
        contact_type: currentActionType,
        content_type: content_type ?? 0,
        content_id: content_id ?? 0,
        schedule_data: schedule_data ?? ''
      };

      dispatch(
        updateCtaSchedule(temp_json_data, (response) => {
          console.log('no id' + JSON.stringify(response));
          currentActionType = '';
          if (response?.status_code == 200 && response?.message) {
            setIsLoading(false);
            getCtaData();
            toast.success(response.message);
            let postObj = {
              cta_type,
              cta_type_id,
              target_type: type,
              target_type_id: type_id,
              position,
              cta_id: id
            };

            dispatch(postAnalyticsCTA(postObj, () => { }));
          }
        })
      );
    } else {
      toast.success('Something Wrong Happen');
    }
  };

  let validateEmailAndPhone = (type) => {
    console.log('click detected' + type);
    if (!email || !phone) {
      console.log('something detected');
      if (!email) {
        setEmailModalShow(true);
        console.log('no email detected' + emailModalShow);
      } else if (!phone) {
        setPhoneModalShow(true);
        console.log('no phone detected' + phoneModalShow);
      } else {
        updateSchedule(type);
        console.log('nothing detected');
      }
    } else {
      updateSchedule(type);
      console.log('nothing detected1');
    }
  };

  let onEmailVerificationComplete = () => {
    // setEmail(getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.email : '');
    setEmail(getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.email : '');
    if (currentActionType && currentActionType == REQUEST_TYPE_CALLBACK) {
      console.log('onEmailVerificationComplete' + REQUEST_TYPE_CALLBACK);
      updateSchedule(REQUEST_TYPE_CALLBACK);
    } else if (currentActionType && currentActionType == REQUEST_TYPE_SCHEDULE) {
      console.log('onEmailVerificationComplete1' + REQUEST_TYPE_SCHEDULE);
      updateSchedule(REQUEST_TYPE_SCHEDULE);
    } else {
      console.log('onEmailVerificationComplete2');
      currentActionType = '';
    }
  };
  let onMobileVerificationComplete = () => {
    setPhone(getLocalStorage('user', false) ? getLocalStorage('user', '{}')?.mobile_primary : '');

    if (currentActionType && currentActionType == REQUEST_TYPE_CALLBACK) {
      console.log('onMobileVerificationComplete' + REQUEST_TYPE_CALLBACK);
      updateSchedule(REQUEST_TYPE_CALLBACK);
    } else if (currentActionType && currentActionType == REQUEST_TYPE_SCHEDULE) {
      console.log('onMobileVerificationComplete 1' + REQUEST_TYPE_SCHEDULE);
      updateSchedule(REQUEST_TYPE_SCHEDULE);
    } else {
      console.log('onMobileVerificationComplete 2');
      currentActionType = '';
    }
  };
  let onEmailHide = () => {
    console.log('onEmailHide 2');
    currentActionType = '';
    if (emailModalShow) {
      setEmailModalShow(false);
    } else {
    }
  };
  let onMobileHide = () => {
    console.log('onMobileHide 2');
    currentActionType = '';
    if (phoneModalShow) {
      setPhoneModalShow(false);
    }
  };
  let onCallBackScheduleClick = () => {
    toast.success(
      `Dear Dr. ${first_name} Your Callback Request Has Been Noted, a CLIRNET Representative Will Be In Touch Shortly!`
    );
  };
  let onCancelPopupClick = () => {
    setIsPopupOpen(false);
    if (emailModalShow) {
      setEmailModalShow(false);
    } else if (phoneModalShow) {
      setPhoneModalShow(false);
    }
  };
  return (
    <>
      {id && !loader ? (
        <div className="w-100 dt_Support position-relative mb-5">
          <div className="rightCardGraph position-absolute top-0 end-0">
            <span className="graphBigCircle position-absolute bg-primary rounded-circle bg-opacity-10"></span>
          </div>
          <div className="dt_SupportTop d-flex justify-content-between align-items-center">
            <DoctubeSupport customClass={'dt_SupportIcon h-auto me-20'} />
            <div className="dt_SupportText text-start flex-1">
              <h5 className="fs-4 fw-normal text-black mb-2">
                Find recording quality videos more difficult than managing patients?
              </h5>
              <h4 className="fs-16 fw-semibold text-black">Contact our executives today</h4>
            </div>
          </div>
          <div className="dt_SupportBtm position-relative p-3 p-md-4 mt-n4">
            <div className="d-flex justify-content-center align-items-center gap-4">
              {callback_status == 1 || schedule_status == 1 ? (
                <a
                  href="javascript:void(0)"
                  className="fs-4 fw-medium btn bg-white text-primary shadow text-capitalize rounded-3 me-3 gtm_cl_doctube_dashboard_sheduleSection_callbackSchedule"
                  onClick={onCallBackScheduleClick}
                >
                  Callback Scheduled
                </a>
              ) : (
                <>
                  {callback_status != 1 && (
                    <a
                      href="javascript:void(0)"
                      className="fs-4 fw-medium btn bg-white text-primary shadow text-capitalize rounded-3 gtm_cl_doctube_dashboard_sheduleSection_callNow"
                      onClick={onRequestCallbackClick}
                      disabled={isLoading}
                    >
                      {!isLoading ? (
                        'Call now'
                      ) : (
                        <Loader type="ThreeDots" color="#f15a29" height={25} width={30} />
                      )}
                    </a>
                  )}
                  {schedule_status != 1 && (
                    <a
                      href="javascript:void(0)"
                      className="fs-4 fw-medium btn bg-white text-primary shadow text-capitalize rounded-3 me-3 gtm_cl_doctube_dashboard_sheduleSection_sheduleCall"
                      onClick={onScheduleClick}
                      disabled={isLoading}
                    >
                      {!isLoading ? (
                        'Schedule Call'
                      ) : (
                        <Loader type="ThreeDots" color="#f15a29" height={25} width={30} />
                      )}
                    </a>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      ) : loader ? (
        <ScheduleSectionSkeleton />
      ) : null}
      {emailModalShow && (
        <EmailUpdateModal
          title="Please Enter Your Email To Schedule An appointment"
          show={emailModalShow}
          onModalHide={onEmailHide}
          onVerificationDone={onEmailVerificationComplete}
        />
      )}
      {phoneModalShow && (
        <PhoneUpdateModal
          show={phoneModalShow}
          onModalHide={onMobileHide}
          onVerificationDone={onMobileVerificationComplete}
        />
      )}
      {popupUrl && (
        <PopupModal
          url={popupUrl ?? ''}
          pageSettings={pageSettings}
          utm={utm}
          prefill={prefill}
          onModalClose={onCancelPopupClick}
          open={isPopupOpen}
          /*
           * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
           * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
           */
          rootElement={document.getElementById('root')}
        />
      )}
    </>
  );
};

export default memo(SheduleSection);
